import React, {
	memo,
	useCallback,
	useEffect,
	useState
} from 'react';
import {
	Loader,
	Segment
} from 'semantic-ui-react';

import {
	handleError,
	log
} from '../../../services/utils';

import { getSimpleVisual } from '../../../api/nora/visual';

import { useUIAction } from '../../../contexts/UIContext';

import Doughnut from './charts/Doughnut';

const SimpleChart = () => {
	const { setApiErrorAlert } = useUIAction();

	const [ isLoading, setIsLoading ] = useState( true );
	const [ data, setData ] = useState( null );
	const [ description, setDescription ] = useState( null );
	const [ label, setLabel ] = useState( null );

	const retrieveCharts = useCallback( async () => {
		try {
			const simple = await getSimpleVisual( 80 );

			const label = simple?.results.label;
			const data = [];
			const backgroundColor = [];
			const labels = [];

			simple
				?.results[ 0 ]
				.values.forEach( ( {
					backColor,
					xVal,
					yVal
				} ) => {
					backgroundColor.push( backColor );
					labels.push( xVal );
					data.push( yVal );
				} );

			setData( {
				labels,
				datasets: [
					{
						label,
						data,
						backgroundColor
					}
				]
			} );
			setDescription( simple.description );
			setLabel( simple.name );
		} catch ( error ) {
			setApiErrorAlert( error );
			throw error;
		}
	}, [ setApiErrorAlert ] );

	useEffect( () => {
		( async () => {
			try {
				await retrieveCharts();
				setIsLoading( false );
			} catch ( error ) {
				if ( error.message !== 'canceled' ) {
					handleError( error );
				}
			}
		} )();
	}, [ retrieveCharts ] );

	return (
		<>
			{ log( 'simpleChart' ) }
			<Segment
				style={ {
					flex: 1,
					margin: '2rem 0',
					minHeight: '343px',
					minWidth: '300px'
				} }
			>
				{ isLoading
					? <Loader
						active
						content="Retrieving chart data..."
					/>
					: <Doughnut
						data={ data }
						description={ description }
						label={ label }
					/>
				}
			</Segment>
		</>
	);
};

export default memo( SimpleChart );
